module.exports = __webpack_public_path__ + "static/img/swipe.48227e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/smart-door/swipe.png
// module id = /DI9
// module chunks = 1